var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.21 19.374H2.5788C1.41954 19.374 0.5 18.4546 0.5 17.2952V2.70408C0.5 1.54482 1.4194 0.62528 2.5788 0.62528H17.1699C18.3292 0.62528 19.2487 1.54468 19.2487 2.70408V17.2952C19.2888 18.4545 18.3692 19.374 17.21 19.374H17.21ZM14.3718 4.50293H5.41692C4.97723 4.50293 4.61744 4.86272 4.61744 5.30241C4.61744 5.7421 4.97723 6.10188 5.41692 6.10188H14.3714C14.8111 6.10188 15.1709 5.7421 15.1709 5.30241C15.171 4.86272 14.8113 4.50293 14.3716 4.50293H14.3718ZM14.3718 9.18013H5.41692C4.97723 9.18013 4.61744 9.53992 4.61744 9.97961C4.61744 10.4193 4.97723 10.7791 5.41692 10.7791H14.3714C14.8111 10.7791 15.1709 10.4193 15.1709 9.97961C15.171 9.53992 14.8113 9.18013 14.3716 9.18013H14.3718ZM14.3718 13.8971H5.41692C4.97723 13.8971 4.61744 14.2569 4.61744 14.6966C4.61744 15.1362 4.97723 15.496 5.41692 15.496H14.3714C14.8111 15.496 15.1709 15.1362 15.1709 14.6966C15.171 14.2569 14.8113 13.8971 14.3716 13.8971H14.3718Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListImg);
export default __webpack_public_path__ + "static/media/listImg.3b6ce5ead8d55d638e6d593eb3d802b0.svg";
export { ForwardRef as ReactComponent };